import store from "../store";

require('es6-promise').polyfill();

// a request helper which reads the access_token from the redux state and passes it in its HTTP request
function __apiRequest(url, method = "GET", body = null) {
    const token = store.getState().oidc.user.access_token;
    const headers = new Headers();
  
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Authorization', `Bearer ${token}`);

    const options = { method, headers, body };
  
    return fetch(url, options)
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then(response => response.json());
}
  
export const GET = (url) => {
    return __apiRequest(url);
}

export const POST = (url, body) => {
    return __apiRequest(url, 'POST', body);
}
